/** Colores estables por producto o categoría (fondos de vitrina sin foto). */

/** Fondos suaves para productos sin foto: cada producto conserva siempre el suyo. */
const TINTS = [
  ["#fbe7e3", "#b4382c"],
  ["#e6f1fa", "#1d5f9e"],
  ["#fdf0dc", "#a3600a"],
  ["#f6efd6", "#7a6210"],
  ["#e6ebfa", "#2f4a9e"],
  ["#e0f4ec", "#17775c"],
  ["#fce8f0", "#a32f63"],
  ["#efeaf9", "#5b3fa8"],
] as const;

export function tintFor(seed: string): (typeof TINTS)[number] {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  return TINTS[Math.abs(hash) % TINTS.length];
}

/** Color de marca de una categoría para su ícono en el riel. */
export function categoryTint(seed: string): { background: string; color: string } {
  const [background, color] = tintFor(seed);
  return { background, color };
}

/** Hasta dos iniciales de un nombre. */
export function initialsOf(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}
